import { apiUrl, authHeaders } from "./auth";

export const fetchGlobal = async (query = "") => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/global/search?query=${encodeURIComponent(query.trim())}`;
  const resp = await fetch(url, {
    method: "get",
    headers,
  });
  return await resp.json();
};
